import { Component,  OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';
import * as uuid from 'uuid';
import { LanguageService } from 'src/app/_services/language.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrl: './user-edit.component.scss',
  providers: [MessageService],
})
export class UserEditComponent implements OnInit {
  clonedSez: { [s: string]: any } = {};
  clonedQuads: { [s: string]: any } = {};

  @ViewChild('maintable') maintable:any;
  
  @ViewChild('maintableQuads') maintableQuads:any;

  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  tabsFields:any[]=[];
  elencocameras:any[]=[];
  elencoquads:any[]=[];
  pageTitle:string="Nuovo utente";
  backUrl:string='/users';
  action:any='';
  loading:boolean = true;
 
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    public lang:LanguageService
  ) { }

  ngOnInit(): void {
   
    let modulefields=this.globalService.configModules.filter((m)=>m.name=='users');
    this.tabsFields=modulefields[0].tabsFields;

    this.action=this.route.snapshot.paramMap.get('action');
  

    
  
    
    if(this.route.snapshot.paramMap.get('id')){
      this.pageTitle="Modifica profilo utente";
      this.apiService.post('app/users_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.model = data2.Result[0];
        this.model['password']='';

        /*
        this.tabsFields[0].fields.forEach((f:any)=>{
          f.fieldGroup.forEach((fg:any,ind:number,obj:any)=>{
             if(fg.key=='password'){
              obj.splice(ind,1);
             }
          });
        });
         this.tabsFields[0].fields.forEach((f:any)=>{
          f.fieldGroup.forEach((fg:any,ind:number,obj:any)=>{
             if(fg.key=='passwordrepeat'){
              obj.splice(ind,1);
             }
          });
        });
        */
        this.loading=false;

      });
    } else {
     
      
      this.loading=false;
    }
 
    
  }

  
  save(){
    if(this.model['password']==''){
      delete this.model['password'];
    }
    this.model['loggedUser']=this.globalService.getUser().id;
    this.apiService.post('app/user_update',this.model).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      setTimeout(()=>{
        this.router.navigateByUrl(this.backUrl);
      },2000);
    
    });

  }

  delete(){

  }


  nuovoRecord() {
    const newS:any = {
      id:uuid.v4(),
      nome: ''
    };
 
    this.model.cameras.unshift(newS);
    //Caution: guard again dataKey here
    this.maintable.editingRowKeys[newS[this.maintable.dataKey]] = true;
    this.onRowEditInit(newS);
  }

  nuovoRecordQuads() {
    const newS:any = {
      id:uuid.v4(),
      nome: ''
    };
 
    this.model.quads.unshift(newS);
    //Caution: guard again dataKey here
    this.maintableQuads.editingRowKeys[newS[this.maintableQuads.dataKey]] = true;
    this.onRowEditInitQuads(newS);
  }

  onRowEditInit(sez: any) {
    this.clonedSez[sez.id] = { ...sez };
  }
  
  onRowEditInitQuads(sez: any) {
    this.clonedQuads[sez.id] = { ...sez };
  }

  onRowEditSaveQuads(quad: any) {
    if (quad.nome!='') {
      delete this.clonedSez[quad.id];
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Nome è obbligatorio',
      });
    }
  }

  onRowEditSave(camera: any) {
    if (camera.nome!='') {
      delete this.clonedSez[camera.id];
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Nome è obbligatorio',
      });
    }
  }

  onRowEditCancel(camera: any, index: number) {
    this.model.cameras[index] = this.clonedSez[camera.id];
    delete this.model.cameras[camera.id];
  }

  

  
  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  
  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
  
  
  
}
